import React from 'react'
import { Link } from 'react-router-dom'
import SubmitButton from 'Components/Form/SubmitButton'

const SettingsTileUnstyled = ({
  className,
  label,
  linkLabel,
  path = ' ',
  onClick = false,
}) => (
  <div className={className}>
    <div>{label}</div>
    {onClick ? (
      <SubmitButton onClick={onClick} size="small">
        {linkLabel}
      </SubmitButton>
    ) : (
      <Link to={path}>
        <SubmitButton size="small">{linkLabel}</SubmitButton>
      </Link>
    )}
  </div>
)

export { SettingsTileUnstyled }



// WEBPACK FOOTER //
// ./src/Components/Settings/SettingsTile/unstyled.js